import React, { useCallback, useEffect, useState } from "react";
import { getCategory } from "../../Services/CategoryApi";
import { getTerminalCategoryScraper } from "../../Services/terminal";
import Select from "react-tailwindcss-select";
import { isNil, uniq } from "lodash";
import { useAppConfig } from "../../Path/AppDashboard";
import CategoryEditRequest from "./CategoryEditRequest";
import CreateCategoryApp from "./CreateCategoryApp";
import { useTranslation } from "react-i18next";
import DataTable from "../../common/DataTable";
import { getTableColumns } from "../../Constants/Coloumns";
import { getScrapingStatus } from "../../Services/AiScrapperApi";

// TODO: REMOVE THIS CODE AS THIS NOT FOR PROD
const PROD_URL = "https://start.heidi-app.de";
const baseURL = process.env.REACT_APP_API_BASE_URL;
const isProdEnv = baseURL.includes(PROD_URL);

const CategoryScraperForm = ({ success, handleSucess }) => {
  const { appConfig, setAppConfig } = useAppConfig();
  const [categories, setCategories] = useState();
  const [showModal, setShowModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const { t } = useTranslation();
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getCategory();
        const apiData = response?.data?.data;
        setCategories(apiData);
        if (appConfig?.cityId) {
          try {
            const res = await getTerminalCategoryScraper(appConfig?.cityId);
            const scrapers = res?.data?.data || [];
            setAppConfig((prev) => ({
              ...prev,
              scrapers: scrapers?.map((scr) => ({
                ...scr,
                isValidScrapper: true,
                link: scr?.link || "",
              })),
            }));
          } catch (scraperErr) {
            console.error("Error fetching scrapers:", scraperErr);
          }
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, [success, appConfig?.cityId]);

  useEffect(() => {
    if (appConfig.categoryIds?.length) {
      const SS = categories?.filter((s) =>
        appConfig?.categoryIds?.includes(s?.id)
      );
      setAppConfig((prev) => ({
        ...prev,
        selectedCategoriesIds: appConfig.selectedCategoriesIds
          ? appConfig.selectedCategoriesIds
          : SS ?? [],
      }));
    }
  }, [categories, appConfig.categoryIds]);
  
  const onRemoveCtegory = (id) => {
    setAppConfig((prev) => ({
      ...prev,
      selectedCategoriesIds: prev?.selectedCategoriesIds.filter(
        (ser) => ser?.id !== id
      ),
    }));
  };

  const fetchScrapingStatus = useCallback(async () => {
    try {
      const response = await getScrapingStatus();
      const apiData = response?.data?.data;
      console.log("Scraping Status Data:", apiData);
      setTableData(apiData);
    } catch (error) {
      console.error("Error fetching scraping status:", error);
      // Show user-friendly error message
      if (error.response?.status === 302) {
        console.warn(
          "API endpoint is redirecting. This might indicate the endpoint doesn't exist or has moved."
        );
      }
    }
  }, []);

  useEffect(() => {
    if (!isProdEnv) {
      fetchScrapingStatus();
    }
  }, [fetchScrapingStatus, isProdEnv]);

  return (
    <div className="mt-6">
      <h2 className="text-2xl font-bold mb-4 text-white">
        {t("CategoryScraperSetup")}
      </h2>
      <CategoryEditRequest
        cityId={appConfig?.cityId}
        selectedCategoriesIds={appConfig.selectedCategoriesIds}
        deleteCategories={onRemoveCtegory}
        handleSucess={handleSucess}
        setAppConfig={setAppConfig}
        scrapers={appConfig?.scrapers}
      />
      <form className="max-w-sm">
        <label
          htmlFor="countries"
          className="block mb-2 text-sm font-medium text-white"
        >
          {t("SelectCategory")}
        </label>
        <Select
          primaryColor="indigo"
          placeholder={t("select")}
          isMultiple
          onChange={(val) => {
            if (
              isNil(appConfig?.selectedCategoriesIds) ||
              appConfig?.selectedCategoriesIds?.length >= 0
            ) {
              setAppConfig((prev) => ({
                ...prev,
                selectedCategoriesIds:
                  uniq([...(prev?.selectedCategoriesIds ?? []), ...val]) ?? [],
              }));
            }
          }}
          options={
            categories
              ?.filter(
                (s) =>
                  !appConfig?.selectedCategoriesIds?.find(
                    (ser) => ser.id === s.id
                  )
              )
              ?.map((cities) => ({
                value: cities?.id,
                label: cities?.name,
                ...cities,
              })) ?? []
          }
        />
      </form>
      {/* {appConfig?.selectedCategoriesIds?.length >= 3 && <p className="text-md text-red-400">{t("maximum_limit")}</p>} */}
      <button
        onClick={() => setShowModal(true)}
        className="text-sm text-primary hover:underline mt-2 bg-blue-600 py-2 px-4 rounded font-semibold text-white"
      >
        {t("category_button")}
      </button>

      {/* Data Table */}
      {!isProdEnv && (
        <div className="mt-6">
          {/* Refresh Button */}
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-white">
              {t("ScrapingStatus")}
            </h3>
            <button
              onClick={() => {
                // Add your refresh logic here
                fetchScrapingStatus();
              }}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
              {t("Refresh")}
            </button>
          </div>
          <DataTable
            data={tableData}
            columns={getTableColumns()}
            showScrollbar={tableData && tableData.length > 2}
            maxHeight="250px"
            emptyStateMessage={t("No_data")}
            emptyStateSubMessage={t("refreshtoload")}
          />
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <CreateCategoryApp
          cityId={appConfig?.cityId}
          isOpen={showModal}
          close={(refetch) => setShowModal(false)}
          handleSucess={handleSucess}
          scrapers={appConfig?.scrapers}
        />
      )}
    </div>
  );
};

export default CategoryScraperForm;
